module.exports = __webpack_public_path__ + "img/button-back-with-border.4a89ac9e.svg";